export enum LeaveQueueLogMessages {
  FINISH_TAKING_CALLS_CLICK = 'Finish taking calls click',
}
